import searchIcon from '@assets/images/search-icon.svg'

import { Container, SearchIconContainer, SearchIconImg, Input } from './SearchBar.styled'

interface Props {
  value: string
  onChange: (value: string) => void
  className?: string
  placeholder?: string
}

export const SearchBar = (props: Props): JSX.Element => {
  const { value, onChange, className, placeholder } = props

  return (
    <Container className={className}>
      <SearchIconContainer>
        <SearchIconImg src={searchIcon} />
      </SearchIconContainer>

      <Input
        placeholder={placeholder}
        value={value}
        onChange={(e) => {
          onChange(e.target.value)
        }}
      />
    </Container>
  )
}
